
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Clock,
  Search,
  Filter,
  Calendar,
  Users,
  FileText,
  CheckCircle2,
  AlertCircle,
  XCircle,
  Eye,
  Send,
  ChevronLeft,
  ChevronRight,
  MoreHorizontal,
  Download,
  RefreshCw,
  TrendingUp,
  Activity,
  Database
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Badge } from "../../components/reusableComponents/Badge";
import { Card, CardContent } from "../../ui/Card";
import releveHeuresService from "../../services/releveHeuresService";
import { toast } from "react-toastify";

// Données mock pour la liste des relevés d'heures
const mockTimeSheets= [
  {
    id: "TS-20241209",
    weekNumber: 3,
    year: 2024,
    startDate: "09/12/2024",
    endDate: "15/12/2024",
    employeeName: "KUMBA MHRIA",
    employeePosition: "MANUTENTIONNAIRE",
    employeeCompany: "LES GARTRES",
    employeeId: "1412_5",
    clientName: "Dupont Construction",
    status: "a_saisir",
    totalHours: 23.0,
    lastUpdated: "09/12/2024 14:30"
  },
  {
    id: "TS-20241202",
    weekNumber: 2,
    year: 2024,
    startDate: "02/12/2024",
    endDate: "08/12/2024",
    employeeName: "KUMBA MHRIA",
    employeeCompany: "LES GARTRES",
    employeeId: "1412_5",
    clientName: "Dupont Construction",
    status: "integrated",
    totalHours: 35.5,
    lastUpdated: "08/12/2024 18:15"
  },
  {
    id: "TS-20241202-2",
    weekNumber: 2,
    year: 2024,
    startDate: "02/12/2024",
    endDate: "08/12/2024",
    employeeName: "MARTIN PHILIPPE",
    employeePosition: "ELECTRICIEN",
    employeeCompany: "ELECTRO PRO",
    employeeId: "1587_3",
    clientName: "Electricité Générale",
    status: "a_saisir",
    totalHours: 42.0,
    lastUpdated: "07/12/2024 12:00"
  },
  {
    id: "TS-20241125",
    weekNumber: 1,
    year: 2024,
    startDate: "25/11/2024",
    endDate: "01/12/2024",
    employeeName: "DUBOIS ALAIN",
    employeePosition: "MACON",
    employeeCompany: "BATIMENT PLUS",
    employeeId: "1632_7",
    clientName: "Habitat Construction",
    status: "a_valider",
    totalHours: 39.0,
    lastUpdated: "03/12/2024 09:45"
  },
  {
    id: "TS-20241125-2",
    weekNumber: 1,
    year: 2024,
    startDate: "25/11/2024",
    endDate: "01/12/2024",
    employeeName: "GARCIA SOPHIE",
    employeePosition: "SECRÉTAIRE",
    employeeCompany: "SECRETARIAT PRO",
    employeeId: "1729_4",
    clientName: "Cabinet Juridique Martin",
    status: "pending",
    totalHours: 28.5,
    lastUpdated: "28/11/2024 15:20"
  },
  {
    id: "TS-20241118",
    weekNumber: 52,
    year: 2023,
    startDate: "18/11/2024",
    endDate: "24/11/2024",
    employeeName: "LEROY THOMAS",
    employeePosition: "OPÉRATEUR",
    employeeCompany: "INDUSTRIE TECH",
    employeeId: "1845_2",
    clientName: "Usine Metallurgique",
    status: "pending",
    totalHours: 40.0,
    lastUpdated: "25/11/2024 10:30"
  },
    {
    id: "TS-20241111",
    weekNumber: 51,
    year: 2023,
    startDate: "11/11/2024",
    endDate: "17/11/2024",
    employeeName: "MARTIN LOUISE",
    employeePosition: "ASSISTANTE RH",
    employeeCompany: "RH EXPERTS",
    employeeId: "1901_8",
    clientName: "Groupe Santé Pro",
    status: "a_valider",
    totalHours: 37,
    lastUpdated: "18/11/2024 10:10"
  },
  {
    id: "TS-20241104",
    weekNumber: 50,
    year: 2023,
    startDate: "04/11/2024",
    endDate: "10/11/2024",
    employeeName: "BOUCHER LÉA",
    employeePosition: "COMPTABLE",
    employeeCompany: "COMPTA SERVICES",
    employeeId: "1902_9",
    clientName: "Cabinet Fiscal Dupuis",
    status: "pending",
    totalHours: 35,
    lastUpdated: "11/11/2024 09:00"
  },
  {
    id: "TS-20241028",
    weekNumber: 49,
    year: 2023,
    startDate: "28/10/2024",
    endDate: "03/11/2024",
    employeeName: "NGUYEN THI",
    employeePosition: "DÉVELOPPEUSE WEB",
    employeeCompany: "DEV & CO",
    employeeId: "1910_3",
    clientName: "Agence Digitale Webnova",
    status: "a_saisir",
    totalHours: 40,
    lastUpdated: "04/11/2024 17:30"
  },
  {
    id: "TS-20241021",
    weekNumber: 48,
    year: 2023,
    startDate: "21/10/2024",
    endDate: "27/10/2024",
    employeeName: "BEN ALI YASSINE",
    employeePosition: "TECHNICIEN IT",
    employeeCompany: "INFOTECH",
    employeeId: "1911_4",
    clientName: "Hôpital Saint-Michel",
    status: "a_valider",
    totalHours: 38.5,
    lastUpdated: "28/10/2024 08:45"
  },
  {
    id: "TS-20241014",
    weekNumber: 47,
    year: 2023,
    startDate: "14/10/2024",
    endDate: "20/10/2024",
    employeeName: "KIM JI-HOON",
    employeePosition: "CHEF DE PROJET",
    employeeCompany: "PMO SOLUTIONS",
    employeeId: "1912_5",
    clientName: "Banque Nationale",
    status: "pending",
    totalHours: 39,
    lastUpdated: "21/10/2024 09:15"
  },
  {
    id: "TS-20241007",
    weekNumber: 46,
    year: 2023,
    startDate: "07/10/2024",
    endDate: "13/10/2024",
    employeeName: "LAMBERT JULIEN",
    employeePosition: "INGÉNIEUR SÉCURITÉ",
    employeeCompany: "CYBERPRO",
    employeeId: "1913_6",
    clientName: "Ministère de la Défense",
    status: "integrated",
    totalHours: 41,
    lastUpdated: "14/10/2024 16:10"
  },
  {
    id: "TS-20241001",
    weekNumber: 45,
    year: 2023,
    startDate: "30/09/2024",
    endDate: "06/10/2024",
    employeeName: "OLIVIER ANNE",
    employeePosition: "SECRÉTAIRE",
    employeeCompany: "BUREAUTIQUE PRO",
    employeeId: "1914_7",
    clientName: "Association Locale",
    status: "a_saisir",
    totalHours: 32,
    lastUpdated: "07/10/2024 13:00"
  },
  {
    id: "TS-20240924",
    weekNumber: 44,
    year: 2023,
    startDate: "23/09/2024",
    endDate: "29/09/2024",
    employeeName: "TOURE MAMADOU",
    employeePosition: "MAGASINIER",
    employeeCompany: "LOGISTIX",
    employeeId: "1915_8",
    clientName: "Centrale d’Achat Nord",
    status: "a_valider",
    totalHours: 40,
    lastUpdated: "30/09/2024 11:00"
  },
  {
    id: "TS-20240917",
    weekNumber: 43,
    year: 2023,
    startDate: "16/09/2024",
    endDate: "22/09/2024",
    employeeName: "FERRARI LUCA",
    employeePosition: "CARRELEUR",
    employeeCompany: "BATIRAPIDE",
    employeeId: "1916_9",
    clientName: "Immobilier Vinci",
    status: "pending",
    totalHours: 36.5,
    lastUpdated: "23/09/2024 07:45"
  },
  {
    id: "TS-20240910",
    weekNumber: 42,
    year: 2023,
    startDate: "09/09/2024",
    endDate: "15/09/2024",
    employeeName: "ZHANG MEI",
    employeePosition: "GRAPHISTE",
    employeeCompany: "CREA STUDIO",
    employeeId: "1917_0",
    clientName: "Startup X",
    status: "integrated",
    totalHours: 34,
    lastUpdated: "16/09/2024 14:50"
  },
  {
    id: "TS-20240903",
    weekNumber: 41,
    year: 2023,
    startDate: "02/09/2024",
    endDate: "08/09/2024",
    employeeName: "DIALLO FATOU",
    employeePosition: "AGENTE D'ENTRETIEN",
    employeeCompany: "PROPRETÉ URBAINE",
    employeeId: "1920_1",
    clientName: "Mairie de Lyon",
    status: "a_saisir",
    totalHours: 30,
    lastUpdated: "09/09/2024 10:30"
  },
  {
    id: "TS-20240827",
    weekNumber: 40,
    year: 2023,
    startDate: "26/08/2024",
    endDate: "01/09/2024",
    employeeName: "MOREAU HUGO",
    employeePosition: "LIVREUR",
    employeeCompany: "EXPRESS LIVRAISON",
    employeeId: "1921_2",
    clientName: "E-commerce Rapid",
    status: "pending",
    totalHours: 39.5,
    lastUpdated: "02/09/2024 09:45"
  },
  {
    id: "TS-20240820",
    weekNumber: 39,
    year: 2023,
    startDate: "19/08/2024",
    endDate: "25/08/2024",
    employeeName: "PETIT LÉA",
    employeePosition: "ASSISTANTE MARKETING",
    employeeCompany: "MARKETPRO",
    employeeId: "1922_3",
    clientName: "Vente Privée SAS",
    status: "a_valider",
    totalHours: 37,
    lastUpdated: "26/08/2024 15:00"
  },
  {
    id: "TS-20240813",
    weekNumber: 38,
    year: 2023,
    startDate: "12/08/2024",
    endDate: "18/08/2024",
    employeeName: "CHEIKH NDIAYE",
    employeePosition: "CHAUFFEUR PL",
    employeeCompany: "TRANSPORT 75",
    employeeId: "1923_4",
    clientName: "BTP Livraison",
    status: "a_saisir",
    totalHours: 40,
    lastUpdated: "19/08/2024 11:20"
  },
  {
    id: "TS-20240806",
    weekNumber: 37,
    year: 2023,
    startDate: "05/08/2024",
    endDate: "11/08/2024",
    employeeName: "GIRARD ÉLISE",
    employeePosition: "STANDARDISTE",
    employeeCompany: "ACCUEIL PRO",
    employeeId: "1924_5",
    clientName: "Cabinet Médical Pasteur",
    status: "pending",
    totalHours: 28,
    lastUpdated: "12/08/2024 08:00"
  },
    {
    id: "TS-20240730",
    weekNumber: 36,
    year: 2023,
    startDate: "29/07/2024",
    endDate: "04/08/2024",
    employeeName: "GONZALEZ MARIA",
    employeePosition: "RÉCEPTIONNISTE",
    employeeCompany: "ACCUEIL SERVICES",
    employeeId: "1930_1",
    clientName: "Hôtel Central",
    status: "pending",
    totalHours: 31.5,
    lastUpdated: "05/08/2024 09:30"
  },
  {
    id: "TS-20240723",
    weekNumber: 35,
    year: 2023,
    startDate: "22/07/2024",
    endDate: "28/07/2024",
    employeeName: "LEFEBVRE PIERRE",
    employeePosition: "AGENT DE SÉCURITÉ",
    employeeCompany: "SECURITÉ PLUS",
    employeeId: "1931_2",
    clientName: "Centre Commercial Nord",
    status: "pending",
    totalHours: 40,
    lastUpdated: "29/07/2024 14:00"
  },
  {
    id: "TS-20240716",
    weekNumber: 34,
    year: 2023,
    startDate: "15/07/2024",
    endDate: "21/07/2024",
    employeeName: "KONE ISMAËL",
    employeePosition: "AGENT LOGISTIQUE",
    employeeCompany: "DISTRILOG",
    employeeId: "1932_3",
    clientName: "Amazon France",
    status: "pending",
    totalHours: 38.5,
    lastUpdated: "22/07/2024 16:20"
  }
];



const RelevesHeuresListe = () => {
  const navigate = useNavigate();
  const [timesheets, setTimesheets] = useState([]);
  const [mockTimesheets] = useState(mockTimeSheets); // Garder les mocks pour fallback
  const [currentPage, setCurrentPage] = useState(1);
  const [currentWeek, setCurrentWeek] = useState(3);
  const [currentYear] = useState(2024);
  const itemsPerPage = 20;

  const [filters, setFilters] = useState({
    search: "",
    status: "all",
    period: "current"
  });
  const [showArchived, setShowArchived] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [useRealData, setUseRealData] = useState(true); // Toggle pour basculer entre vraies données et mocks

  const removeDiacritics = (str) =>
    str?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Charger les relevés d'heures depuis l'API (pour le freelance connecté)
  const loadReleveHeures = async () => {
    setIsLoading(true);
    try {
      // Utilise getMyReleveHeures() pour récupérer uniquement les relevés du freelance connecté
      const data = await releveHeuresService.getMyReleveHeures();

      // Vérifier que les données sont valides
      if (!data || !Array.isArray(data)) {
        console.warn('Données API invalides, utilisation des données mockées');
        if (useRealData) {
          setTimesheets(mockTimesheets); // Fallback sur les mocks
          toast.warning('Aucune donnée API trouvée, affichage des données de démonstration');
        }
        return;
      }

      // Transformer les données backend vers le format frontend
      const transformedData = data
        .filter(item => item != null) // Filtrer les éléments null/undefined
        .map(item => {
          try {
            return releveHeuresService.transformToFrontendFormat(item);
          } catch (transformError) {
            console.warn('Erreur lors de la transformation d\'un élément:', transformError, item);
            return null;
          }
        })
        .filter(item => item != null); // Filtrer les transformations échouées

      // Mettre à jour les données affichées
      if (useRealData) {
        setTimesheets(transformedData);
        console.log('✅ Relevés d\'heures réels chargés:', transformedData);
        toast.success(`${transformedData.length} relevé(s) d'heures chargé(s) depuis l'API`);
      }

    } catch (error) {
      console.error('Erreur lors du chargement des relevés d\'heures:', error);
      toast.error('Erreur lors du chargement des relevés d\'heures');

      // En cas d'erreur, utiliser les données mockées
      if (useRealData) {
        setTimesheets(mockTimesheets);
        toast.warning('Erreur API, affichage des données de démonstration');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Charger les relevés d'heures pour un client spécifique
  const loadReleveHeuresByClient = async () => {
    setIsLoading(true);
    try {
      const data = await releveHeuresService.getReleveHeuresByClient();

      // Vérifier que les données sont valides
      if (!data || !Array.isArray(data)) {
        console.warn('Données API invalides pour client, utilisation des données mockées');
        if (useRealData) {
          setTimesheets(mockTimesheets);
          toast.warning('Aucune donnée client trouvée, affichage des données de démonstration');
        }
        return;
      }

      const transformedData = data
        .filter(item => item != null)
        .map(item => {
          try {
            return releveHeuresService.transformToFrontendFormat(item);
          } catch (transformError) {
            console.warn('Erreur lors de la transformation d\'un élément client:', transformError, item);
            return null;
          }
        })
        .filter(item => item != null);

      if (useRealData) {
        setTimesheets(transformedData);
        console.log('✅ Relevés d\'heures par client chargés:', transformedData);
        toast.success(`${transformedData.length} relevé(s) client chargé(s) depuis l'API`);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des relevés d\'heures par client:', error);
      toast.error('Erreur lors du chargement des relevés d\'heures');

      if (useRealData) {
        setTimesheets(mockTimesheets);
        toast.warning('Erreur API client, affichage des données de démonstration');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect pour charger les données au démarrage
  useEffect(() => {
    if (useRealData) {
      loadReleveHeures();
    } else {
      setTimesheets(mockTimesheets);
    }
  }, [useRealData]);

  // Fonction pour basculer entre données réelles et mocks
  const toggleDataSource = () => {
    setUseRealData(prev => {
      const newValue = !prev;
      if (newValue) {
        loadReleveHeures(); // Charger les vraies données
        toast.info('Basculement vers les données API');
      } else {
        setTimesheets(mockTimesheets); // Utiliser les mocks
        toast.info('Basculement vers les données de démonstration');
      }
      return newValue;
    });
  };

  // Fonction de test pour vérifier l'intégration
  const testIntegration = async () => {
    console.log('🧪 Test d\'intégration des relevés d\'heures');

    try {
      // Test 1: Motifs d'absence
      console.log('Test 1: Chargement des motifs d\'absence...');
      const motifs = await releveHeuresService.getMotifAbsence();
      console.log('✅ Motifs d\'absence:', motifs);

      // Test 2: Mes relevés (freelance connecté)
      console.log('Test 2: Chargement de mes relevés d\'heures...');
      const myReleves = await releveHeuresService.getMyReleveHeures();
      console.log('✅ Mes relevés d\'heures:', myReleves);

      // Test 3: Tous les relevés (admin)
      console.log('Test 3: Chargement de tous les relevés (admin)...');
      const allReleves = await releveHeuresService.getAllReleveHeures();
      console.log('✅ Tous les relevés (admin):', allReleves);

      // Test 4: Relevés par client (même que Test 2 mais via l'autre méthode)
      console.log('Test 4: Chargement des relevés par client...');
      const clientReleves = await releveHeuresService.getReleveHeuresByClient();
      console.log('✅ Relevés par client:', clientReleves);

      toast.success('Tests d\'intégration terminés ! Voir la console pour les détails.');
    } catch (error) {
      console.error('❌ Erreur lors des tests:', error);
      toast.error('Erreur lors des tests d\'intégration');
    }
  };

  // Fonction de filtrage des relevés d'heures
  const filteredTimesheets = timesheets.filter(timesheet => {
    // Filtre par recherche (nom de l'employé, ID, client)
    const searchMatch = filters.search === "" ||
      timesheet.employeeName.toLowerCase().includes(filters.search.toLowerCase()) ||
      removeDiacritics(timesheet.employeePosition)?.includes(removeDiacritics(filters.search));

    // Filtre par statut, en excluant les "integrated" si showArchived est false
    const statusMatch = showArchived
      ? timesheet.status === 'integrated'
      : (filters.status === "all" ? timesheet.status !== 'integrated' : timesheet.status === filters.status);

    return searchMatch && statusMatch;
  });

  const totalPages = Math.ceil(filteredTimesheets.length / itemsPerPage);
  const paginatedTimesheets = filteredTimesheets.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Statistiques pour les métriques
  const stats = {
    total: timesheets.length,
    pending: timesheets.filter(t => t.status === "pending").length,
    aSaisir: timesheets.filter(t => t.status === "a_saisir").length,
    aValider: timesheets.filter(t => t.status === "a_valider").length,
    integrated: timesheets.filter(t => t.status === "integrated").length,
    totalHours: timesheets.reduce((sum, t) => sum + t.totalHours, 0)
  };

  // Fonction pour naviguer vers la page de détails d'un relevé d'heures
  const viewTimesheet = (id) => {
    navigate(`/RelevesHeures?id=${id}`);
  };

  // Fonction pour envoyer une relance
  const sendReminder = (timesheet) => {
    const updatedTimesheets = [...timesheets];
    const index = updatedTimesheets.findIndex(t => t.id === timesheet.id);
    if (index !== -1) {
      updatedTimesheets[index] = { ...updatedTimesheets[index], reminderSent: true };
      setTimesheets(updatedTimesheets);
    }
  };

  // Fonction pour obtenir la couleur et l'icône du statut
  const getStatusInfo = (status) => {
    switch(status) {
      case "pending":
        return {
          color: "bg-amber-50 text-amber-700 border-amber-200",
          icon: <Clock className="w-4 h-4" />,
          label: "En attente"
        };
      case "a_saisir":
        return {
          color: "bg-red-50 text-red-700 border-red-200",
          icon: <AlertCircle className="w-4 h-4" />,
          label: "À saisir"
        };
      case "a_valider":
        return {
          color: "bg-orange-50 text-orange-700 border-orange-200",
          icon: <FileText className="w-4 h-4" />,
          label: "À valider"
        };
      case "integrated":
        return {
          color: "bg-emerald-50 text-emerald-700 border-emerald-200",
          icon: <CheckCircle2 className="w-4 h-4" />,
          label: "Intégré"
        };
      default:
        return {
          color: "bg-slate-50 text-slate-700 border-slate-200",
          icon: <XCircle className="w-4 h-4" />,
          label: status
        };
    }
  };
  
  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="w-full p-8">
        {/* Header Section */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="p-3 bg-blue-100 rounded-xl">
                  <Clock className="w-8 h-8 text-blue-600" />
                </div>
                <div>
                  <h1 className="text-4xl font-bold text-slate-900">
                    Relevés d'Heures
                  </h1>
                  <p className="text-lg text-slate-600">
                    Gestion et suivi des feuilles de temps
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <motion.button
                onClick={() => setShowArchived(!showArchived)}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  showArchived
                    ? 'bg-slate-900 text-white'
                    : 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-50'
                }`}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {showArchived ? 'Voir les actifs' : 'Voir les archives'}
              </motion.button>

              <motion.button
                className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 flex items-center space-x-2"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Download className="w-4 h-4" />
                <span>Exporter</span>
              </motion.button>
            </div>
          </div>
        </motion.div>
        {/* Métriques Principales */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {/* Total Heures */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Clock className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">Total Heures</p>
                  <p className="text-xs text-slate-500">Cette période</p>
                </div>
              </div>
              <TrendingUp className="w-4 h-4 text-blue-500" />
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">{stats.totalHours}h</p>
              <p className="text-xs text-slate-500">Heures déclarées</p>
            </div>
          </motion.div>

          {/* À Saisir */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-red-100 rounded-lg">
                  <AlertCircle className="w-5 h-5 text-red-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">À Saisir</p>
                  <p className="text-xs text-slate-500">Action requise</p>
                </div>
              </div>
              <Activity className="w-4 h-4 text-red-500" />
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">{stats.aSaisir}</p>
              <p className="text-xs text-slate-500">Relevés en attente</p>
            </div>
          </motion.div>

          {/* À Valider */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-orange-100 rounded-lg">
                  <FileText className="w-5 h-5 text-orange-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">À Valider</p>
                  <p className="text-xs text-slate-500">En révision</p>
                </div>
              </div>
              <CheckCircle2 className="w-4 h-4 text-orange-500" />
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">{stats.aValider}</p>
              <p className="text-xs text-slate-500">En attente validation</p>
            </div>
          </motion.div>

          {/* Intégrés */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-emerald-100 rounded-lg">
                  <CheckCircle2 className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">Intégrés</p>
                  <p className="text-xs text-slate-500">Terminés</p>
                </div>
              </div>
              <Activity className="w-4 h-4 text-emerald-500" />
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">{stats.integrated}</p>
              <p className="text-xs text-slate-500">Relevés traités</p>
            </div>
          </motion.div>
        </motion.div>

        {/* Filtres et Navigation */}
        <motion.div
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {/* Recherche */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Recherche</label>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Nom, poste, entreprise..."
                  value={filters.search}
                  onChange={(e) => {
                    setFilters(prev => ({ ...prev, search: e.target.value }));
                    setCurrentPage(1);
                  }}
                  className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>

            {/* Statut */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Statut</label>
              <div className="relative">
                <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
                <select
                  value={filters.status}
                  onChange={(e) => {
                    setFilters(prev => ({ ...prev, status: e.target.value }));
                    setCurrentPage(1);
                  }}
                  className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                  disabled={showArchived}
                >
                  <option value="all">Tous les statuts</option>
                  <option value="pending">En attente</option>
                  <option value="a_saisir">À saisir</option>
                  <option value="a_valider">À valider</option>
                  <option value="integrated">Intégrés</option>
                </select>
              </div>
            </div>

            {/* Navigation semaine */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Semaine</label>
              <div className="flex items-center space-x-2">
                <motion.button
                  className="p-2 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors duration-200"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setCurrentWeek(prev => prev - 1)}
                >
                  <ChevronLeft className="w-4 h-4 text-slate-600" />
                </motion.button>

                <div className="flex-1 text-center">
                  <span className="text-sm font-medium text-slate-900">Semaine {currentWeek}</span>
                  <p className="text-xs text-slate-500">{currentYear}</p>
                </div>

                <motion.button
                  className="p-2 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors duration-200"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setCurrentWeek(prev => prev + 1)}
                >
                  <ChevronRight className="w-4 h-4 text-slate-600" />
                </motion.button>
              </div>
            </div>

            {/* Actions */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Actions</label>
              <div className="flex space-x-2">
                <motion.button
                  onClick={() => {
                    setFilters({ search: "", status: "all", period: "current" });
                    setCurrentPage(1);
                    loadReleveHeures(); // Recharger les données
                  }}
                  disabled={isLoading}
                  className={`flex-1 px-3 py-2 border border-slate-200 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center justify-center space-x-1 ${
                    isLoading
                      ? "text-slate-400 cursor-not-allowed"
                      : "text-slate-700 hover:bg-slate-50"
                  }`}
                  whileHover={!isLoading ? { scale: 1.02 } : {}}
                  whileTap={!isLoading ? { scale: 0.98 } : {}}
                >
                  <RefreshCw className={`w-4 h-4 ${isLoading ? "animate-spin" : ""}`} />
                  <span>{isLoading ? "Chargement..." : "Actualiser"}</span>
                </motion.button>

                <motion.button
                  onClick={testIntegration}
                  className="flex-1 px-3 py-2 border border-blue-200 bg-blue-50 rounded-lg text-sm font-medium text-blue-700 hover:bg-blue-100 transition-colors duration-200 flex items-center justify-center space-x-1"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Activity className="w-4 h-4" />
                  <span>Test API</span>
                </motion.button>

                <motion.button
                  onClick={toggleDataSource}
                  className={`flex-1 px-3 py-2 border rounded-lg text-sm font-medium transition-colors duration-200 flex items-center justify-center space-x-1 ${
                    useRealData
                      ? "border-green-200 bg-green-50 text-green-700 hover:bg-green-100"
                      : "border-orange-200 bg-orange-50 text-orange-700 hover:bg-orange-100"
                  }`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {useRealData ? (
                    <>
                      <Database className="w-4 h-4" />
                      <span>API</span>
                    </>
                  ) : (
                    <>
                      <FileText className="w-4 h-4" />
                      <span>Demo</span>
                    </>
                  )}
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Liste des Relevés d'Heures */}
        <motion.div
          className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <div className="px-6 py-4 border-b border-slate-200">
            <div className="flex items-center justify-between">
              {/* Indicateur de source de données */}
              <div className="flex items-center space-x-2">
                <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                  useRealData
                    ? "bg-green-100 text-green-800"
                    : "bg-orange-100 text-orange-800"
                }`}>
                  {useRealData ? "🔗 Mes Relevés (API)" : "🎭 Données Demo"}
                </div>
                <span className="text-sm text-slate-500">
                  {timesheets.length} relevé(s) affiché(s)
                </span>
              </div>
              <h3 className="text-lg font-semibold text-slate-900">
                {showArchived ? 'Relevés Archivés' : 'Relevés Actifs'}
              </h3>
              <div className="flex items-center space-x-2 text-sm text-slate-500">
                <span>{filteredTimesheets.length} relevé(s)</span>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-slate-200">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                    Intérimaire
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                    Client & Période
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                    Heures
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                    Statut
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-200">
                <AnimatePresence>
                  {filteredTimesheets.length > 0 ? (
                    paginatedTimesheets.map((timesheet, index) => {
                      const statusInfo = getStatusInfo(timesheet.status);
                      return (
                        <motion.tr
                          key={timesheet.id}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -20 }}
                          transition={{ duration: 0.3, delay: index * 0.05 }}
                          className="hover:bg-slate-50 cursor-pointer transition-colors duration-200"
                          onClick={() => viewTimesheet(timesheet.id)}
                        >
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <div className="flex-shrink-0 h-10 w-10">
                                <div className="h-10 w-10 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center">
                                  <span className="text-sm font-medium text-white">
                                    {timesheet.employeeName.split(' ').map(n => n[0]).join('').substring(0, 2)}
                                  </span>
                                </div>
                              </div>
                              <div className="ml-4">
                                <div className="text-sm font-medium text-slate-900">{timesheet.employeeName}</div>
                                <div className="text-sm text-slate-500">{timesheet.employeePosition}</div>
                                <div className="text-xs text-slate-400">{timesheet.employeeCompany} • {timesheet.employeeId}</div>
                              </div>
                            </div>
                          </td>

                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-slate-900 font-medium">{timesheet.clientName}</div>
                            <div className="text-sm text-slate-500">
                              {timesheet.startDate} → {timesheet.endDate}
                            </div>
                            <div className="text-xs text-slate-400">Semaine {timesheet.weekNumber}</div>
                          </td>

                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-lg font-bold text-slate-900">{timesheet.totalHours}h</div>
                            <div className="text-xs text-slate-500">Déclarées</div>
                          </td>

                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${statusInfo.color}`}>
                              {statusInfo.icon}
                              <span className="ml-1">{statusInfo.label}</span>
                            </span>
                          </td>

                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                            <div className="flex items-center justify-end space-x-2">
                              {timesheet.status === "a_saisir" && (
                                <motion.button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    sendReminder(timesheet);
                                  }}
                                  className="p-2 text-amber-600 hover:text-amber-900 hover:bg-amber-50 rounded-lg transition-colors duration-200"
                                  whileHover={{ scale: 1.1 }}
                                  whileTap={{ scale: 0.9 }}
                                  title="Envoyer une relance"
                                >
                                  <Send className="w-4 h-4" />
                                </motion.button>
                              )}

                              <motion.button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  viewTimesheet(timesheet.id);
                                }}
                                className="p-2 text-blue-600 hover:text-blue-900 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                title="Voir les détails"
                              >
                                <Eye className="w-4 h-4" />
                              </motion.button>

                              <motion.button
                                className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-colors duration-200"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                title="Plus d'options"
                              >
                                <MoreHorizontal className="w-4 h-4" />
                              </motion.button>
                            </div>
                          </td>
                        </motion.tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5} className="px-6 py-12 text-center">
                        <div className="flex flex-col items-center">
                          <FileText className="w-12 h-12 text-slate-300 mb-4" />
                          <h3 className="text-sm font-medium text-slate-900 mb-1">Aucun relevé trouvé</h3>
                          <p className="text-sm text-slate-500">
                            Aucun relevé d'heures ne correspond à vos critères de recherche.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </AnimatePresence>
              </tbody>
            </table>
          </div>
        </motion.div>
        {/* Pagination */}
        {totalPages > 1 && (
          <motion.div
            className="flex justify-between items-center mt-8 px-6 py-4 bg-white rounded-xl shadow-sm border border-slate-200"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <div className="flex items-center space-x-2 text-sm text-slate-600">
              <span>Page {currentPage} sur {totalPages}</span>
              <span>•</span>
              <span>{paginatedTimesheets.length} sur {filteredTimesheets.length} relevés</span>
            </div>

            <div className="flex items-center space-x-2">
              <motion.button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="p-2 rounded-lg border border-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                whileHover={{ scale: currentPage === 1 ? 1 : 1.05 }}
                whileTap={{ scale: currentPage === 1 ? 1 : 0.95 }}
              >
                <ChevronLeft className="w-4 h-4 text-slate-600" />
              </motion.button>

              <div className="flex items-center space-x-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  const pageNum = i + 1;
                  return (
                    <motion.button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`px-3 py-1 rounded-lg text-sm font-medium transition-colors duration-200 ${
                        currentPage === pageNum
                          ? 'bg-blue-600 text-white'
                          : 'text-slate-600 hover:bg-slate-100'
                      }`}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      {pageNum}
                    </motion.button>
                  );
                })}
              </div>

              <motion.button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="p-2 rounded-lg border border-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                whileHover={{ scale: currentPage === totalPages ? 1 : 1.05 }}
                whileTap={{ scale: currentPage === totalPages ? 1 : 0.95 }}
              >
                <ChevronRight className="w-4 h-4 text-slate-600" />
              </motion.button>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default RelevesHeuresListe;